exports["NL"] = require("./NL.js");
exports["SE"] = require("./SE.js");
exports["ES"] = require("./ES.js");